<template>
  <v-card>
    <v-card class="pl-8 pr-8 pt-8 pb-8">
      <v-row>
        <v-col class="text-right">
          <div fill-width class="pb-5" align="end">
            <v-btn class="mx-2" fab small dark color="#c1d4d7" @click="closetomytimesheet()">
              <v-icon small color="blue">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- <div fill-width class="pb-5" align="end">
          <v-btn
            class="mx-2"
            fab
            dark
            color="#689ADE"
            @click="saveAdvanceDraft()"
          >
            <v-icon color="black">
              mdi-close
            </v-icon>
          </v-btn>
        </div> -->
      <v-card-title>
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <h3>{{ timesheet_name }}</h3>
          </v-col>
          <v-col cols="6" md="6">
            <v-row>
              <v-col class="text-right" cols="12" md="12">
                <h5>No. {{ noheadertimesheet }}</h5>
                <h5>Date {{ dateheadertimesheet }}</h5>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>

      <v-row class="row1 mt-3  pt-3 ">
        <v-col cols="12" md="6">
          <v-text-field v-model="setusername" outlined disabled dense label="Employee Name"
            background-color="#F5F5F5"></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field v-model="department" outlined disabled dense label="Department"
            background-color="#F5F5F5"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field v-model="headerItem.remark" :disabled="disableinstatus" fill-width outlined dense
            label="Remark"></v-text-field>
        </v-col>
      </v-row>

      <br />

      <template>
        <v-row>
          <v-col class="text-right">
            <div fill-width class="pb-5" align="end">
              <v-btn :disabled="disableinstatus" @click="openaddItemdetail()" color="#0A7EA5" rounded dark class="mb-2">
                <span>Add</span>
                <v-icon small center>add</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!--   hide-default-footer -->
        <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1">
          <template v-slot:item.jobtitle_name="{ item }">
            <!-- {{ item }} -->
            <v-autocomplete v-model="item.jobtitle_id" :items="jobtitle_list" item-text="name" item-value="id"
              @change="onSelectCustomerChange(showeditedItem.jobtitle_id)" dense></v-autocomplete>
          </template>
          <template v-slot:item.customer_name="{ item }">
            <!-- {{ item }} -->
            <v-autocomplete v-model="item.customer_id" :items="customer_list" item-text="name" item-value="id"
              @change="onSelectCustomerChange(showeditedItem.customer_id)" dense></v-autocomplete>
          </template>

          <template v-slot:item.checkin="{ item }">
            <!-- {{ item }} -->
            <datetime class="border-dt-picker pt-2 pl-2 max-width130" type="datetime" value-zone="Asia/Bangkok"
              format="dd/MM/yyyy HH:mm" v-model="item.checkin"></datetime>
          </template>

          <template v-slot:item.checkout="{ item }">
            <!-- {{ item }} -->
            <datetime class="border-dt-picker pt-2 pl-2 max-width130" type="datetime" value-zone="Asia/Bangkok"
              format="dd/MM/yyyy HH:mm" v-model="item.checkout"></datetime>
          </template>
          <template v-slot:item.showhours="{ item }">
            <!-- {{ item }} -->
            <v-text-field type="number" min="0" v-model="item.showhours" dense></v-text-field>
          </template>
          <template v-slot:item.showactualchargehour="{ item }">
            <!-- {{ item }} -->
            <v-text-field type="number" min="0" v-model="item.showactualchargehour" dense></v-text-field>
          </template>

          <template v-slot:item.chargetypename="{ item }">
            <!-- {{ item }} -->
            <v-autocomplete v-model="item.chargetype" :items="charge_list" item-text="name" item-value="value"
              dense></v-autocomplete>
          </template>

          <template v-slot:item.prospect="{ item }">
            <!-- {{ item }} -->
            <v-text-field dense v-model="item.prospect"></v-text-field>
          </template>

          <template v-slot:item.detail="{ item }">
            <!-- {{ item }} -->
            <v-textarea v-model="item.detail" multi-line dense rows="1" auto-grow outlined></v-textarea>
          </template>

          <template v-slot:item.actions="{ item }">
            <!-- <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->

            <v-icon :disabled="disableinstatus" :style="{
              backgroundColor: '#E1F5FE',
              color: '#2196F3',
            }" @click="openeditItem(item)">
              mdi-pencil
            </v-icon>

            <v-icon :disabled="disableinstatus" class="ml-2" :style="{
              backgroundColor: '#FFEBEE',
              color: '#F44336',
            }" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="loaddatadetails">
              Reset
            </v-btn>
          </template>
        </v-data-table>
        <v-row class="mt-7 mb-5" align="center" justify="center">
          <v-btn v-if="desserts.length > 0" :style="{
            backgroundColor: '#4169E1',
            color: 'white',
          }" @click="saveeditdetails">
            บันทึกการแก้ไข
          </v-btn>
        </v-row>
      </template>

      <!-- <template>
        <div class="pl-2 pr-2 pt-5 elevation-1 heightsize55formadvance">
          <v-row>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-1"
            ></v-text-field>
            <v-autocomplete
              class="width-14"
              v-model="addItem.jobtitle_id"
              label="jobtitle"
              :items="jobtitle_list"
              item-text="name"
              item-value="id"
              outlined
              @change="onSelectCustomerChange(addItem.jobtitle_id)"
              dense
            ></v-autocomplete>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-1"
            ></v-text-field>
            <v-autocomplete
              class="width-14"
              v-model="addItem.customer_id"
              :items="customer_list"
              label="customer"
              item-text="name"
              item-value="id"
              outlined
              @change="onSelectCustomerChange(addItem.customer_id)"
              dense
            ></v-autocomplete>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-1"
            ></v-text-field>
            <v-menu
              v-model="menuadd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="width-10"
                  v-model="a"
                  append-icon="mdi-calendar"
                  label="check-in"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="a"
                @input="menuadd = false"
                @change="finddatafromdate"
              ></v-date-picker>
            </v-menu>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-1"
            ></v-text-field>
            <v-menu
              v-model="menuadd2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="width-10"
                  v-model="a"
                  append-icon="mdi-calendar"
                  label="check-out"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="a"
                @input="menuadd2 = false"
                @change="finddatafromdate"
              ></v-date-picker>
            </v-menu>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-5"
            ></v-text-field>
            <v-text-field
              class="width-5"
              dense
              v-model="addItem.chargetype"
              label="chargetype"
              outlined
            ></v-text-field>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-1"
            ></v-text-field>
            <v-text-field
              class="width-5"
              dense
              v-model="addItem.prospect"
              label="prospect"
              outlined
            ></v-text-field>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-1"
            ></v-text-field>
            <v-text-field
              class="width-14"
              dense
              v-model="addItem.detail"
              @keydown.tab="savedetailtimesheet()"
              @keydown.enter="savedetailtimesheet()"
              label="detail"
              outlined
            ></v-text-field>
            <v-text-field
              :style="{ visibility: hidebtninsert ? 'visible' : 'hidden' }"
              class="width-10"
            ></v-text-field>
          </v-row>
        </div>
      </template> -->

      <br />
      <v-row justify="center" class="mt-2">
        <v-col align="center" cols="12" md="4">
          <v-row v-if="dialogSignature" :style="{ visibility: showsig2 ? 'visible' : 'hidden' }" align="center"
            justify="center">
            <VueSignaturePad class="signature" width="60%" height="200" ref="RequestersignaturePad"
              :options="options" />
            <v-row :style="{
              visibility: showbuttonsavesig2 ? 'visible' : 'hidden',
            }">
              <v-col align="center">
                <v-btn depressed class="ml-5" @click="clearsig2()">
                  Clear
                </v-btn>
              </v-col>
              <v-col>
                <v-btn class="mr-5 mb-5 primary" depressed @click="savesig2()">
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
          <v-btn :style="{
            visibility: showbuttonsavesig2 ? 'visible' : 'hidden',
          }" disabled class="mr-2 mb-5" @click="editsig2()">
            {{ defaultwordbuttonsig2 }}
            <v-icon right>mdi-border-color</v-icon>
          </v-btn>
          <br />
          <hr />
          <p class="text-center">Requester</p>
          <p class="text-center" v-if="lbl_date_request">
            Date {{ datedate_request }}
          </p>
        </v-col>
        <v-col align="center" cols="12" md="4">
          <v-row v-if="dialogSignature" :style="{ visibility: showsig1 ? 'visible' : 'hidden' }" align="center"
            justify="center">
            <VueSignaturePad class="signature" width="60%" height="200" ref="ApproversignaturePad" :options="options" />
            <v-row :style="{
              visibility: showbuttonsavesig1 ? 'visible' : 'hidden',
            }">
              <v-col align="center">
                <v-btn depressed class="ml-5" @click="clearsig1()">
                  Clear
                </v-btn>
              </v-col>
              <v-col>
                <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
          <v-btn :disabled="disableinstatus" class="mr-2 mb-5" @click="editsig1()">
            {{ defaultwordbuttonsig1 }}
            <v-icon right>mdi-border-color</v-icon>
          </v-btn>
          <br />
          <hr />
          <p class="text-center">Approver</p>
          <p class="text-center" v-if="lbl_date_request">
            Date {{ dateCurrent }}
          </p>
        </v-col>
      </v-row>
      <br />
      <hr />
      <br />
      <div :style="{ display: showbtnadd ? 'show' : 'none' }">
        <v-row>
          <v-col align="center" cols="12" md="12">
            <v-btn :disabled="disableinstatus" class="mr-5 buttonblue btn-width" @click="savetimesheetApprove()">
              Approve
            </v-btn>
            <v-btn :disabled="disableinstatus" depressed outlined class="mr-5 " @click="savetimesheetReturn()">
              Return
            </v-btn>
            <v-btn :disabled="disableinstatus" depressed outlined class="buttonred btn-width"
              @click="savetimesheetReject()">
              Reject
            </v-btn>
          </v-col>
        </v-row>

        <!-- <v-row>
            <v-col align="end" cols="12" md="12">
              <v-btn depressed class="buttonred">
                Delete form
              </v-btn>
            </v-col>
          </v-row> -->
      </div>
    </v-card>

    <v-dialog v-model="dialogadddetail" max-width="90%">
      <v-card>
        <v-card-title class="text-h6"></v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="space-around">
              <v-col cols="12" sm="3" md="3">
                <h3>Assignment</h3>
                <v-autocomplete v-model="showaddItem.jobtitle_id" :items="jobtitle_list" label="jobtitle"
                  item-text="name" item-value="id" outlined @change="onSelectCustomerChange(showaddItem.jobtitle_id)"
                  dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Client</h3>
                <v-autocomplete label="Client" v-model="showaddItem.customer_id" :items="customer_list" item-text="name"
                  item-value="id" outlined @change="onSelectCustomerChange(showaddItem.customer_id)"
                  dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Charge Type</h3>
                <v-autocomplete v-model="showaddItem.chargetype" :items="charge_list" label="Charge Type"
                  item-text="name" item-value="value" outlined dense></v-autocomplete>

                <!-- :items="statusall"
                
                  item-text="cgm_name"
                  item-value="id"
                  v-model="itemedit.status"
                  
                  @change="changeSPGroupMenu"
                  required
                  :rules="commonRules" -->
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Prospect</h3>
                <v-text-field label="Prospect" dense v-model="showaddItem.prospect" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-col cols="12" sm="3" md="3">
                <v-row>
                  <v-col cols="12" sm="7" md="7">
                    <v-menu v-model="menuadd" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <h3>Check-In</h3>
                        <v-text-field label="Check-In" v-model="computedDateCheckInFormatted" append-icon="mdi-calendar"
                          readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                      </template>

                      <v-date-picker v-model="showaddItem.checkin" @input="menuadd = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="5" md="5">
                    <h3>Time</h3>
                    <datetime class="border-dt-picker minheighttime" type="time" input-id="menutimeadd"
                      value-zone="Asia/Bangkok" format="HH:mm:ss" v-model="showaddItem.timecheckin"></datetime>
                    <!-- <v-menu
                      ref="menutime"
                      v-model="menutimeadd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <h3
                          :style="{
                            visibility: showtitletimecheckin
                              ? 'visible'
                              : 'hidden',
                          }"
                        >
                          Time
                        </h3>
                        <v-text-field
                          v-model="showaddItem.timecheckin"
                          append-icon="mdi-clock-time-four-outline"
                          label="Time-Check-In"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        use-seconds
                        v-model="showaddItem.timecheckin"
                        @input="menutimeadd = false"
                      ></v-time-picker>
                    </v-menu> -->
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-row>
                  <v-col cols="12" sm="7" md="7">
                    <v-menu v-model="menuadd2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <h3>Check-Out</h3>
                        <v-text-field label="Check-Out" v-model="computedDateCheckOutFormatted"
                          append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                      </template>

                      <v-date-picker v-model="showaddItem.checkout" @input="menuadd2 = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="5" md="5">
                    <h3>Time</h3>
                    <datetime class="border-dt-picker minheighttime" type="time" input-id="menutimeadd"
                      value-zone="Asia/Bangkok" format="HH:mm:ss" v-model="showaddItem.timecheckout"></datetime>
                    <!-- <v-menu
                      ref="menutime2"
                      v-model="menutimeadd2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <h3
                          :style="{
                            visibility: showtitletimecheckin
                              ? 'visible'
                              : 'hidden',
                          }"
                        >
                          Time
                        </h3>
                        <v-text-field
                          v-model="showaddItem.timecheckout"
                          append-icon="mdi-clock-time-four-outline"
                          label="Time-Check-Out"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        use-seconds
                        v-model="showaddItem.timecheckout"
                        @input="menutimeadd2 = false"
                      ></v-time-picker>
                    </v-menu> -->
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Work Hour Duration</h3>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Hour" type="number" min="0" v-model="showaddItem.durationhour"
                      append-icon="mdi-clock-time-four-outline" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="minute" type="number" min="0" v-model="showaddItem.durationminute"
                      append-icon="mdi-clock-time-four-outline" outlined dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3"></v-col>
            </v-row>
            <v-row justify="space-around">
              <v-col cols="12" sm="12" md="12">
                <h3>Details</h3>
                <v-textarea label="Details" v-model="showaddItem.detail" multi-line outlined dense></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveaddItem()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="closeaddItem()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogedit" max-width="90%">
      <v-card>
        <v-card-title class="text-h6">Create Activity by :{{ showActivity_create }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="space-around">
              <v-col cols="12" sm="3" md="3">
                <h3>Assignment</h3>
                <v-autocomplete v-model="showeditedItem.jobtitle_id" :items="jobtitle_list" item-text="name"
                  item-value="id" outlined @change="onSelectCustomerChange(showeditedItem.jobtitle_id)"
                  dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Client</h3>
                <v-autocomplete v-model="showeditedItem.customer_id" :items="customer_list" item-text="name"
                  item-value="id" outlined @change="onSelectCustomerChange(showeditedItem.customer_id)"
                  dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Charge Type</h3>
                <v-autocomplete v-model="showeditedItem.chargetype" :items="charge_list" item-text="name"
                  item-value="value" outlined dense></v-autocomplete>

                <!-- :items="statusall"
                
                  item-text="cgm_name"
                  item-value="id"
                  v-model="itemedit.status"
                  
                  @change="changeSPGroupMenu"
                  required
                  :rules="commonRules" -->
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Prospect</h3>
                <v-text-field dense v-model="showeditedItem.prospect" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-col cols="12" sm="3" md="3">
                <v-row>
                  <v-col cols="12" sm="7" md="7">
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <h3>Check-In</h3>
                        <v-text-field v-model="showeditedItem.checkin" append-icon="mdi-calendar" readonly
                          v-bind="attrs" v-on="on" outlined dense></v-text-field>
                      </template>

                      <v-date-picker v-model="showeditedItem.checkin" @input="menu = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="5" md="5">
                    <h3>Time</h3>
                    <datetime class="border-dt-picker minheighttime" type="time" input-id="menutime"
                      value-zone="Asia/Bangkok" format="HH:mm:ss" v-model="showeditedItem.timecheckin"></datetime>
                    <!-- <v-menu
                      ref="menutime"
                      v-model="menutime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <h3
                          :style="{
                            visibility: showtitletimecheckin
                              ? 'visible'
                              : 'hidden',
                          }"
                        >
                          Time
                        </h3>
                        <v-text-field
                          v-model="showeditedItem.timecheckin"
                          append-icon="mdi-clock-time-four-outline"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        use-seconds
                        v-model="showeditedItem.timecheckin"
                        full-width
                        @click:minute="
                          $refs.menutime.save(showeditedItem.timecheckin)
                        "
                      ></v-time-picker>
                    </v-menu> -->
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-row>
                  <v-col cols="12" sm="7" md="7">
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <h3>Check-Out</h3>
                        <v-text-field v-model="showeditedItem.checkout" append-icon="mdi-calendar" readonly
                          v-bind="attrs" v-on="on" outlined dense></v-text-field>
                      </template>

                      <v-date-picker v-model="showeditedItem.checkout" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="5" md="5">
                    <h3>Time</h3>
                    <datetime class="border-dt-picker minheighttime" type="time" input-id="menutime2"
                      value-zone="Asia/Bangkok" format="HH:mm:ss" v-model="showeditedItem.timecheckout"></datetime>
                    <!-- <v-menu
                      ref="menutime2"
                      v-model="menutime2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <h3
                          :style="{
                            visibility: showtitletimecheckin
                              ? 'visible'
                              : 'hidden',
                          }"
                        >
                          Time
                        </h3>
                        <v-text-field
                          v-model="showeditedItem.timecheckout"
                          append-icon="mdi-clock-time-four-outline"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        use-seconds
                        v-model="showeditedItem.timecheckout"
                        full-width
                        @click:minute="
                          $refs.menutime2.save(showeditedItem.timecheckout)
                        "
                      ></v-time-picker>
                    </v-menu> -->
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Work Hour Duration</h3>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Hour" type="number" min="0" v-model="showeditedItem.durationhour"
                      append-icon="mdi-clock-time-four-outline" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="minute" type="number" min="0" v-model="showeditedItem.durationminute"
                      append-icon="mdi-clock-time-four-outline" outlined dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <h3>Actual Charge Duration</h3>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Hour" type="number" min="0" v-model="showeditedItem.tualchargehour"
                      append-icon="mdi-clock-time-four-outline" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field label="minute" type="number" min="0" v-model="showeditedItem.tualchargeminute"
                      append-icon="mdi-clock-time-four-outline" outlined dense></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-col cols="12" sm="12" md="12">
                <h3>Details</h3>
                <v-textarea v-model="showeditedItem.detail" multi-line outlined dense></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveeditItem()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="closeeditItem()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSendMail" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">Information Saved</v-card-title>
        <v-card-subtitle>
          บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
              >Cancel</v-btn
            > -->
          <v-btn color="blue darken-1" text @click="closeDialogSendmail()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSaveDraft" max-width="30%">
      <v-card>
        <v-card-title primary-title class="justify-center">
          {{ this.messageSaveDraft }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                          >Cancel</v-btn
                        > -->
          <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogtomytimesheet" max-width="30%" scrollable>
      <v-card>
        <v-card-title primary-title class="justify-end">
          <v-icon large @click="canceltomytimesheet()">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-title primary-title class="justify-center">
          Are you sure ?</v-card-title>
        <v-card-title primary-title class="justify-center">
          Changes you made may not be saved
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="confirmtomytimesheet()">
            Ok
          </v-btn>
          <v-btn depressed outlined width="100" @click="canceltomytimesheet()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteForm" max-width="30%" scrollable>
      <v-card>
        <v-card-title primary-title class="justify-end">
          <v-icon large @click="dialogDeleteForm = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-title primary-title class="justify-center">
          Are you sure ?</v-card-title>
        <v-card-title primary-title class="justify-center">
          You want delet this timesheet
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="deleteFormtimesheet()">
            Ok
          </v-btn>
          <v-btn depressed outlined width="100" @click="dialogDeleteForm = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-card>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";

export default {
  name: "NewAdvance",
  data(vm) {
    return {
      timesheet_name: "",
      charge_list: [
        { value: "T/C", name: "T/C" },
        { value: "N/C", name: "N/C" },
        { value: "F/C", name: "F/C" },
        { value: "OFF", name: "OFF" },
      ],
      // charge_list: [
      //   { value: "T/C", name: "Time Charge" },
      //   { value: "N/C", name: "No Charge" },
      //   { value: "F/C", name: "Fix Charge" },
      //   { value: "OFF", name: "ทำงานออฟฟิต" },
      // ],
      showActivity_create: "",
      datedate_request: "",
      noheadertimesheet: "",
      dateheadertimesheet: "",
      dialogDeleteForm: false,
      disableinstatus: false,
      dialogadddetail: false,
      menuaddcheckin: false,
      menuaddcheckout: false,
      menuadd: false,
      menuadd2: false,
      hidebtninsert: false,
      showtitletimecheckin: false,
      menutime: false,
      menutimecheckin: false,
      menutimeadd: false,
      menutime2: false,
      menutimeadd2: false,
      timedatefrom: "00:00:00",
      timedateto: "00:00:00",
      dialogtomytimesheet: false,
      dialogedit: false,
      showbtnadd: true,
      advance_code: [],
      advance_code_list: [],
      advance_code_id: 0,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      customer: [],
      jobtitle_list: [],
      customer_list: [],
      customer_id: 0,
      options: {
        penColor: "#000000",
        backgroundColor: "rgb(255,255,255)",
      },
      initial_data2: "",
      initial_data: "",
      pickbank: false,
      pickcheque: false,
      checkcheque: false,
      checkchequefilled: false,
      showsig1: false,
      showsig2: true,
      showbuttonsavesig1: false,
      showbuttonsavesig2: false,
      defaultwordbuttonsig1: "Signature",
      defaultwordbuttonsig2: "Signature",
      totalleftoveramount: 0.0,
      sumwithdrawamount: 0.0,
      sunamountcleared: 0.0,
      showallamount: "",

      selectbankname: "",
      setusername: "",
      department: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: unity.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),
      datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menuadd: false,
      modal: false,
      menu2: false,
      menuadd2: false,
      search: "",
      selectedProductId: "",
      confirmDeleteDlg: false,
      mDataArray: [],
      // mDataArray: [{ id: "1", detail: "gg", amout: "1000" }],
      fullPage: true,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "Assignment",
          value: "jobtitle_name",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "15%",
        },
        {
          text: "abbname",
          value: "abbname_e_n",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
        },
        {
          text: "Client",
          value: "customer_name",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "15%",
        },
        {
          text: "Check-In",
          value: "checkin",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
        },
        {
          text: "Check-Out",
          value: "checkout",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
        },
        {
          text: "Hour",
          value: "showhours",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "5%",
        },
        {
          text: "Approve Hour",
          value: "showactualchargehour",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "5%",
        },
        {
          text: "Charge Type",
          value: "chargetypename",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "7%",
        },
        {
          text: "Prospect",
          value: "prospect",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "7%",
        },
        {
          text: "Details",
          value: "detail",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          width: "25%",
        },
        {
          text: "",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          sortable: false,
          divider: true,
          align: "center",
          width: "7%",
        },
      ],
      desserts: [],
      headerItem: {
        status: 0,
        remark: "",
        update_by: localStorage.getItem(server.USER_ID),
      },
      showaddItem: {
        jobtitle_id: 0,
        customer_id: 0,
        // checkin: "",
        // checkout: "",
        checkin: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        checkout: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        timecheckin: "",
        timecheckout: "",
        hours: "",
        chargetype: "",
        prospect: "",
        detail: "",
        durationhour: 0,
        durationminute: 0,
      },
      addItem: {
        timesheet_hid: 0,
        jobtitle_id: 0,
        customer_id: 0,
        employeeid: 0,
        checkin: "",
        checkout: "",
        hours: "",
        chargetype: "",
        prospect: "",
        detail: "",
      },
      editedIndex: -1,
      showeditedItem: {
        jobtitle_id: 0,
        customer_id: 0,
        checkin: "",
        checkout: "",
        timecheckin: "",
        timecheckout: "",
        hours: "",
        chargetype: "",
        prospect: "",
        detail: "",
        durationhour: 0,
        durationminute: 0,
        tualchargehour: 0,
        tualchargeminute: 0,
      },
      editedItem_id: 0,
      editedItem: {
        jobtitle_id: 0,
        customer_id: 0,
        checkin: "",
        checkout: "",
        hours: "",
        actualchargehour: "",
        chargetype: "",
        prospect: "",
        detail: "",
      },
      defaultItem: {
        code: "",
        description: "",
        amount: 0,
      },

      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      remark: "",
      sendMail: {
        name: "",
        email: "",
        advance_id: "",
        link: "",
      },
      account: {
        signature: "",
      },
      advance_log: {
        module: "TS",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedDateCheckInFormatted() {
      return unity.formatDate(this.showaddItem.checkin);
    },
    computedDateCheckOutFormatted() {
      return unity.formatDate(this.showaddItem.checkout);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    // this.$showLoader();
    this.$hideLoader();

    this.$forceUpdate();
    this.loaddataheader();
    this.loaddatadetails();
    this.loadCustomer();
    this.loadJobtitle();
    this.loaddepartment();
    const res_acc = await api.getAccountDetail(
      localStorage.getItem(server.USER_ID)
    );

    // alert(res_acc.data[0].department_i_d);

    // console.log("res_acc : ", JSON.stringify(res_acc.data[0].signature));

    this.user_sign = res_acc.data[0].signature;

    this.showsig1 = true;
    this.dialogSignature = true;
    // this.showdefaultsignature();
    this.savesig1();
    // this.$refs.ApproversignaturePad.lockSignaturePad();

    // let yourUrlString = window.location;
    // alert(yourUrlString);

    // let parser = document.createElement("a");
    // parser.href = yourUrlString;

    // parser.protocol; // => "http:"
    // parser.hostname; // => "example.com"
    // parser.port; // => "3000"
    // parser.pathname; // => "/pathname/"
    // parser.search; // => "?search=test"
    // parser.hash; // => "#hash"
    // parser.host; // => "example.com:3000"

    // alert(parser.pathname);

    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    // console.log("Login mounted : " + api.isLoggedIn());
    // console.log("Login mounted : " + userId);
    // await this.loadProducts();
  },
  methods: {
    closeDialogSendmail() {
      this.dialogSendMail = false;
      this.$router.push("/advance-list");
    },
    async loaddepartment() {
      // console.log("loadAdvanceCode");

      let company_id = localStorage.getItem(server.COMPANYID);

      // console.log("loadAdvanceCode company_id:" + company_id);

      const result = await api.getAllAdvanceCodeByCompany(company_id);

      // console.log("loadAdvanceCode : ", JSON.stringify(result.data));
      this.advance_code = result.data;

      result.data.forEach((item) => {
        this.advance_code_list.push(item.code + " " + item.description);
      });
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async savedetailtimesheet() { },
    async savetimesheetApprove() {
      this.headerItem.status = 3;

      this.advance_log.module_id = this.$route.params.id;
      this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
      this.advance_log.approve_status = 3;
      this.advance_log.approve_date = new Date();

      const res_h = await api.getupdatetimesheetH(
        this.$route.params.id,
        this.headerItem
      );

      if (res_h.status == 200 || res_h.status == 201) {
        const res_log = await api.addAdvanceLog(this.advance_log);
        if (res_log.status == 200 || res_log.status == 201) {
          this.loaddatadetails();
          this.dialogadddetail = false;
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            "/approve-time-sheet"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
    },

    async savetimesheetReturn() {
      this.headerItem.status = 1;

      this.advance_log.module_id = this.$route.params.id;
      this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
      this.advance_log.approve_status = 4;
      this.advance_log.approve_date = new Date();
      const res_h = await api.getupdatetimesheetH(
        this.$route.params.id,
        this.headerItem
      );

      if (res_h.status == 200 || res_h.status == 201) {
        const res_log = await api.addAdvanceLog(this.advance_log);
        if (res_log.status == 200 || res_log.status == 201) {
          this.loaddatadetails();
          this.dialogadddetail = false;
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            "/approve-time-sheet"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
    },

    async savetimesheetReject() {
      this.headerItem.status = 5;

      this.advance_log.module_id = this.$route.params.id;
      this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
      this.advance_log.approve_status = 5;
      this.advance_log.approve_date = new Date();
      const res_h = await api.getupdatetimesheetH(
        this.$route.params.id,
        this.headerItem
      );

      if (res_h.status == 200 || res_h.status == 201) {
        const res_log = await api.addAdvanceLog(this.advance_log);
        if (res_log.status == 200 || res_log.status == 201) {
          this.loaddatadetails();
          this.dialogadddetail = false;
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            "/approve-time-sheet"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
    },

    async deleteFormtimesheet() {
      // this.$showLoader();
      const res_add_d = await api.getdeletebyTSIdtimesheetD(
        this.$route.params.id
      );
      const res_add_h = await api.getdeletetimesheetH(this.$route.params.id);

      if (res_add_h.data == 1) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ลบข้อมูล",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          "/approve-time-sheet"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบข้อมูลได้",
          "text-h5 red--text text-center"
        );
      }

      this.$hideLoader();
    },

    async loaddatadetails() {
      const result = await api.getdetailstimesheetD(this.$route.params.id);
      this.desserts = result.data;
      this.desserts.forEach((x) => {
        let setdatetimecheckin = x.checkin.split(" ");
        let setdatetimecheckout = x.checkout.split(" ");
        x.checkin = `${setdatetimecheckin[0]}T${setdatetimecheckin[1]}`;
        x.checkout = `${setdatetimecheckout[0]}T${setdatetimecheckout[1]}`;

        // x.checkin = setdatetimecheckin[0];
        //    x.checkout = setdatetimecheckout[0];
        // x.timecheckin = setdatetimecheckin[1];
        // x.timecheckout = setdatetimecheckout[1];
      });
      console.log(result.data);
    },
    async loaddataheader() {
      const result = await api.getByIdtimesheetH(this.$route.params.id);
      this.timesheet_name = result.data[0].timesheet_name;
      this.headerItem.remark = result.data[0].remark;
      this.headerItem.status = result.data[0].status;
      this.noheadertimesheet = result.data[0].timesheet_id;
      this.dateheadertimesheet = result.data[0].created_at;
      const resultdetail = await api.approvedetailtimesheetH(
        this.$route.params.id
      );
      this.datedate_request = resultdetail.data[0].approve_sucess_date;

      const res_acc = await api.getAccountDetail(
        resultdetail.data[0].employee_id
      );

      this.initial_data2 = res_acc.data[0].signature;

      this.setusername =
        res_acc.data[0].prename_e_n +
        " " +
        res_acc.data[0].firstname_e_n +
        " " +
        res_acc.data[0].lastname_e_n;

      // alert(res_acc.data[0].department_i_d);
      const res_department = await api.getDepartmentByID(
        res_acc.data[0].department_i_d
      );

      this.department = res_department.data[0].name;
      this.showdefaultsignature();
      // if (this.headerItem.status == 2) {
      //   this.disableinstatus = true;
      // } else {
      //   this.disableinstatus = false;
      // }
    },
    async openaddItemdetail() {
      this.showaddItem = {
        jobtitle_id: 0,
        customer_id: 0,
        checkin: "",
        checkout: "",
        timecheckin: "",
        timecheckout: "",
        hours: "",
        chargetype: "",
        prospect: "",
        detail: "",
        durationhour: 0,
        durationminute: 0,
      };
      this.dialogadddetail = true;
    },

    async saveaddItem() {
      if (
        this.showaddItem.jobtitle_id == "" ||
        this.showaddItem.jobtitle_id == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Jobtitle ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.customer_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Client ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.checkin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Date Check-In ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.timecheckin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Time Check-In ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.checkout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Date Check-Out ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.timecheckout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Time Check-Out ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.chargetype == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Charge-Type ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.showaddItem.detail == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Details ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.durationhour < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "duration hour ต้องมากกว่าหรือเท่ากับ 0 ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showaddItem.durationhour == "" ||
        this.showaddItem.durationhour == undefined ||
        this.showaddItem.durationhour == null
      ) {
        this.showaddItem.durationhour = 0;
      }

      if (this.showaddItem.durationminute < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "duration minute ต้องมากกว่าหรือเท่ากับ 0 ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (
        this.showaddItem.durationminute == "" ||
        this.showaddItem.durationminute == undefined ||
        this.showaddItem.durationminute == null
      ) {
        this.showaddItem.durationminute = 0;
      }
      this.$showLoader();

      this.showaddItem.timecheckin = this.showaddItem.timecheckin
        .split("T")[1]
        .split(".000")[0];
      this.showaddItem.timecheckout = this.showaddItem.timecheckout
        .split("T")[1]
        .split(".000")[0];

      this.addItem.timesheet_hid = this.$route.params.id;
      this.addItem.jobtitle_id = this.showaddItem.jobtitle_id;
      this.addItem.customer_id = this.showaddItem.customer_id;
      this.addItem.employeeid = localStorage.getItem(server.USER_ID);
      this.addItem.checkin = `${this.showaddItem.checkin} ${this.showaddItem.timecheckin}`;
      this.addItem.checkout = `${this.showaddItem.checkout} ${this.showaddItem.timecheckout}`;
      // this.addItem.hours = parseFloat(
      //   Math.abs(
      //     new Date(this.addItem.checkin) - new Date(this.addItem.checkout)
      //   ) /
      //     (1000 * 60 * 60)
      // ).toFixed(2);
      this.addItem.chargetype = this.showaddItem.chargetype;
      this.addItem.prospect = this.showaddItem.prospect;
      this.addItem.detail = this.showaddItem.detail;
      this.addItem.hours =
        parseInt(this.showaddItem.durationhour * 60) +
        parseInt(this.showaddItem.durationminute);

      const res_add_d = await api.getaddtimesheetD(this.addItem);
      if (res_add_d.status == 200 || res_add_d.status == 201) {
        await this.loaddatadetails();
        this.dialogadddetail = false;
        this.updatecustomer_timesheet_h();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }

      this.$hideLoader();
    },

    async closeaddItem() {
      this.dialogadddetail = false;
    },

    async openeditItem(item) {
      console.log(item);
      this.editedIndex = this.desserts.indexOf(item);
      this.showeditedItem = Object.assign({}, item);
      this.showActivity_create = item.activity_create;
      this.showeditedItem.durationhour = parseInt(
        this.showeditedItem.hours / 60
      );
      this.showeditedItem.durationminute = parseInt(
        this.showeditedItem.hours % 60
      );

      this.showeditedItem.tualchargehour = parseInt(
        this.showeditedItem.actualchargehour / 60
      );
      this.showeditedItem.tualchargeminute = parseInt(
        this.showeditedItem.actualchargehour % 60
      );
      let getdatetimecheckin = this.showeditedItem.checkin.split(".000")[0];
      let getdatetimecheckout = this.showeditedItem.checkout.split(".000")[0];

      this.showeditedItem.checkin = getdatetimecheckin.split("T")[0];
      this.showeditedItem.checkout = getdatetimecheckout.split("T")[0];
      this.showeditedItem.timecheckin = getdatetimecheckin.split("T")[1];
      this.showeditedItem.timecheckout = getdatetimecheckout.split("T")[1];
      this.dialogedit = true;
    },
    async saveeditItem() {
      if (
        this.showeditedItem.jobtitle_id == "" ||
        this.showeditedItem.jobtitle_id == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Jobtitle ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (
        this.showeditedItem.customer_id == 0 ||
        this.showeditedItem.customer_id == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Client ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showeditedItem.checkin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Date Check-In ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showeditedItem.timecheckin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Time Check-In ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showeditedItem.checkout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Date Check-Out ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showeditedItem.timecheckout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Time Check-Out ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showeditedItem.chargetype == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Charge-Type ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (this.showeditedItem.detail == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Details ",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showeditedItem.durationhour < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "duration hour ต้องมากกว่าหรือเท่ากับ 0 ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showeditedItem.durationhour == "" ||
        this.showeditedItem.durationhour == undefined ||
        this.showeditedItem.durationhour == null
      ) {
        this.showeditedItem.durationhour = 0;
      }
      if (this.showeditedItem.durationminute < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "duration minute ต้องมากกว่าหรือเท่ากับ 0 ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showeditedItem.durationminute == "" ||
        this.showeditedItem.durationminute == undefined ||
        this.showeditedItem.durationminute == null
      ) {
        this.showeditedItem.durationminute = 0;
      }

      if (this.showeditedItem.tualchargehour < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "tualcharge hour ต้องมากกว่าหรือเท่ากับ 0 ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showeditedItem.tualchargehour == "" ||
        this.showeditedItem.tualchargehour == undefined ||
        this.showeditedItem.tualchargehour == null
      ) {
        this.showeditedItem.tualchargehour = 0;
      }

      if (this.showeditedItem.tualchargeminute < 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "tualcharge minute ต้องมากกว่าหรือเท่ากับ 0 ",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showeditedItem.tualchargeminute == "" ||
        this.showeditedItem.tualchargeminute == undefined ||
        this.showeditedItem.tualchargeminute == null
      ) {
        this.showeditedItem.tualchargeminute = 0;
      }
      this.editedItem_id = 0;
      // if (this.desserts.length <= 0) {
      //   // alert("กรุณาเลือกลูกค้า");
      //   // this.messageSaveDraft = "กรุณากรอกรายละเอียด Advance Detail";
      //   // this.dialogSaveDraft = true;
      //   this.$store.state.global_dialog = true;
      //   this.setupAlertDialog(
      //     true,
      //     "Check your information again",
      //     "กรุณากรอกรายละเอียด TimeSheet Detail",
      //     "text-h5 red--text text-center"
      //   );
      //   return;
      // }
      if (this.showeditedItem.timecheckin.search("T") !== -1) {
        this.showeditedItem.timecheckin = this.showeditedItem.timecheckin
          .split("T")[1]
          .split(".000")[0];
      } else {
        this.showeditedItem.timecheckin = this.showeditedItem.timecheckin;
      }
      if (this.showeditedItem.timecheckout.search("T") !== -1) {
        this.showeditedItem.timecheckout = this.showeditedItem.timecheckout
          .split("T")[1]
          .split(".000")[0];
      } else {
        this.showeditedItem.timecheckout = this.showeditedItem.timecheckout;
      }

      this.editedItem_id = this.showeditedItem.timesheet_d_id;
      this.editedItem.jobtitle_id = this.showeditedItem.jobtitle_id;
      this.editedItem.customer_id = this.showeditedItem.customer_id;
      this.editedItem.checkin = `${this.showeditedItem.checkin} ${this.showeditedItem.timecheckin}`;
      this.editedItem.checkout = `${this.showeditedItem.checkout} ${this.showeditedItem.timecheckout}`;
      // this.editedItem.hours = this.showeditedItem.hours;
      this.editedItem.hours =
        parseInt(this.showeditedItem.durationhour * 60) +
        parseInt(this.showeditedItem.durationminute);
      this.editedItem.actualchargehour =
        parseInt(this.showeditedItem.tualchargehour * 60) +
        parseInt(this.showeditedItem.tualchargeminute);
      this.editedItem.chargetype = this.showeditedItem.chargetype;
      this.editedItem.prospect = this.showeditedItem.prospect;
      this.editedItem.detail = this.showeditedItem.detail;
      console.log(this.editedItem);
      const res_d = await api.getupdatetimesheetD(
        this.editedItem_id,
        this.editedItem
      );

      if (res_d.status == 200 || res_d.status == 201) {
        this.loaddatadetails();
        this.dialogedit = false;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center"
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
      }
    },
    async closeeditItem() {
      this.dialogedit = false;
      //   this.$nextTick(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem);
      //     this.editedIndex = -1;
      //   });
    },

    deleteItem(item) {
      // this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.editedItem_id = item.timesheet_d_id;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      // this.desserts.splice(this.editedIndex, 1);
      const resdel = await api.getdeletetimesheetD(this.editedItem_id);
      if (resdel.data == 1) {
        await this.loaddatadetails();
        this.updatecustomer_timesheet_h();
        this.closeDelete();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center"
        );
      } else {
        this.loaddatadetails();
        this.closeDelete();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ลบข้อมูล",
          "ไม่สามารถลบข้อมูลได้",
          "text-h5 red--text text-center"
        );
      }
    },

    closeSaveDraft() {
      this.dialogSaveDraft = false;
    },

    closeDelete() {
      this.editedItem_id = 0;
      this.dialogDelete = false;
      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // });
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },

    async loadCustomer() {
      // console.log("loadCustomer");
      const result = await api.getAllCustomerListactiveCompany(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        }
      );
      // console.log("result.data : ", JSON.stringify(result.data));
      this.customer_list = result.data;
    },

    editsig1() {
      this.dialogSignature = true;
      this.lbl_date_request = false;
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      this.$refs.ApproversignaturePad.openSignaturePad();
    },
    editsig2() {
      this.showsig2 = true;
      this.showbuttonsavesig2 = true;
      this.$refs.RequestersignaturePad.openSignaturePad();
    },
    clearsig1() {
      this.lbl_date_request = false;
      this.$refs.ApproversignaturePad.clearSignature();
    },
    clearsig2() {
      this.$refs.RequestersignaturePad.clearSignature();
    },
    async savesig1() {
      this.lbl_date_request = true;
      this.defaultwordbuttonsig1 = "Edit";
      const { isEmpty, data } = this.$refs.ApproversignaturePad.saveSignature();
      this.showbuttonsavesig1 = false;
      this.$refs.ApproversignaturePad.lockSignaturePad();
      // console.log("user_sign : " + data);
      // console.log("user_sign1 : " + this.user_sign);
      this.user_sign = data;
      this.account.signature = data;

      await api.updateAccount(
        localStorage.getItem(server.USER_ID),
        this.account
      );
      loader.hide();
    },
    savesig2() {
      this.defaultwordbuttonsig2 = "Edit";
      const {
        isEmpty,
        data,
      } = this.$refs.RequestersignaturePad.saveSignature();
      this.showbuttonsavesig2 = false;
      this.$refs.RequestersignaturePad.lockSignaturePad();
    },

    showdefaultsignature() {
      this.$nextTick(() => {
        // this.$refs.signaturePaddefault.fromDataURL(this.initial_data);
        // this.$refs.signaturePaddefault.lockSignaturePad();
        this.$refs.ApproversignaturePad.fromDataURL(this.user_sign);
        this.$refs.ApproversignaturePad.lockSignaturePad();
        this.$refs.RequestersignaturePad.fromDataURL(this.initial_data2);
        this.$refs.RequestersignaturePad.lockSignaturePad();
      });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },

    closetomytimesheet() {
      this.dialogtomytimesheet = true;
    },
    confirmtomytimesheet() {
      this.dialogtomytimesheet = false;
      this.$router.push("/approve-time-sheet");
    },
    canceltomytimesheet() {
      this.dialogtomytimesheet = false;
    },
    async saveeditdetails() {
      console.log(this.desserts);
      // this.editedItem.hours = this.showeditedItem.hours;
      this.desserts.forEach(async (x, index) => {
        x.hours = parseInt(x.showhours * 60);
        // +
        // parseInt(x.durationminute);
        x.actualchargehour = parseInt(x.showactualchargehour * 60);
        console.log(x);
        // return;
        const res_d = await api.getupdatetimesheetD(x.timesheet_d_id, x);
        if (index == this.desserts.length - 1) {
          this.updatecustomer_timesheet_h();
          if (res_d.status == 200 || res_d.status == 201) {
            this.loaddatadetails();
            this.dialogedit = false;
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "Information successfully saved",
              "text-h5 green--text text-center"
            );
          } else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center"
            );
          }
        }
      });

      // +
      // parseInt(this.desserts.tualchargeminute);
      // this.desserts.chargetype = this.desserts.chargetype;
      // this.desserts.prospect = this.desserts.prospect;
      // this.desserts.detail = this.desserts.detail;
    },
    async updatecustomer_timesheet_h() {
      let firstcheckcusforupdatetimesheet_h = 0;
      let checkcusforupdatetimesheet_h = 0;
      let datadifferent = false;
      this.desserts.forEach(async (x, index) => {
        if (index == 0) {
          if (this.desserts.length == 1) {
            checkcusforupdatetimesheet_h = x.customer_id;
          }
          firstcheckcusforupdatetimesheet_h = x.customer_id;
        } else {
          if (datadifferent == false) {
            if (firstcheckcusforupdatetimesheet_h == x.customer_id) {
              checkcusforupdatetimesheet_h = x.customer_id;
            } else {
              checkcusforupdatetimesheet_h = 0;
              datadifferent = true;
            }
          }
        }
        if (index == this.desserts.length - 1) {
          await api.getupdatetimesheetH(this.$route.params.id, {
            customer_id: checkcusforupdatetimesheet_h,
          });
          // if (res_d.status == 200 || res_d.status == 201) {
          //   this.loaddatadetails();
          //   this.dialogedit = false;
          //   this.$store.state.global_dialog = true;
          //   this.setupAlertDialog(
          //     true,
          //     "Information Saved",
          //     "Information successfully saved",
          //     "text-h5 green--text text-center"
          //   );
          // } else {
          //   this.$store.state.global_dialog = true;
          //   this.setupAlertDialog(
          //     true,
          //     "Information Saved",
          //     "ไม่สามารถบันทึกได้",
          //     "text-h5 red--text text-center"
          //   );
          // }
        }
      });
    },
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}

.btn-width {
  width: 120px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  background-color: white;
  color: black;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}

.width-1 {
  width: 1%;
}

.width-3 {
  width: 3%;
}

.width-5 {
  width: 5%;
}

.width-8 {
  width: 8%;
}

.width-10 {
  width: 10%;
}

.width-14 {
  width: 14%;
}

.btnuploadfile {
  border: 2px solid;
}

.border-dt-picker {
  border: 1px solid;
  /* border-radius: 5px; */
  height: 30px;
}

.v-application .pt-2 {
  padding-top: 4px !important;
}

.v-application .pl-2 {
  padding-left: 8px !important;
}

.minheighttime {
  min-height: 40px;
  cursor: pointer;
  font-size: initial;
  padding-top: 8px;
  padding-left: 8px;
}

.max-width130 {
  max-width: 130px;
}
</style>
